// extracted by mini-css-extract-plugin
module.exports = {"list":"Payment_list_2yzhX","card":"Payment_card_2fxHo","icon":"Payment_icon_VM64I"};